<template>
  <div class="zmdetbanner between">
    <div class="left">
      <div class="lt">抢劫罪</div>
      <div class="flex_start">
        <img src="../../../assets/zuimindetail/zan.png" />
        <span>0</span>
        <img src="../../../assets/zuimindetail/kan.png" />
        <span>89</span>
      </div>
    </div>
    <div class="right">
      <div class="rt">律观网刑法罪名库</div>
      <div class="iconlist flex">
        <div class="iconitem">
          <div>
            <img src="../../../assets/zuimindetail/shoukao.png" alt="" />
          </div>
          <div>482个罪名收录</div>
        </div>
        <div class="iconitem">
          <div><img src="../../../assets/zuimindetail/maozi.png" alt="" /></div>
          <div>严谨层次化呈现</div>
        </div>

        <div class="iconitem">
          <div><img src="../../../assets/zuimindetail/lvshi.png" alt="" /></div>
          <div>专业资深律师审阅</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.zmdetbanner {
  width: 1200px;
  margin: 0 auto 50px;
  padding: 74px 60px;
  height: 300px;
  align-items: flex-start;
  background: url("../../../assets/zuimindetail/zmdetbanner_sample.png");
  .left {
    color: #ffffff;
    .lt {
      font-size: 34px;
      margin-top: 16px;
      margin-bottom: 44px;
    }
    img {
      margin-right: 16px;
    }
    span {
      margin-right: 44px;
      font-size: 20px;
    }
  }
  .right {
    width: 350px;
    height: 152px;
    padding: 20px 22px;
    background-color: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    color: #ffffff;
    .rt {
      font-size: 22px;
    }
    .iconlist {
      font-size: 12px;
      text-align: center;
      .iconitem {
        flex: 1;
        img {
          width: 34px;
          height: 34px;
          margin-top: 22px;
          margin-bottom: 12px;
        }
      }
    }
  }
}
</style>